exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cropper-dialog {\n  width: 560px !important;\n  max-height: none;\n}\n.cropper-dialog .el-dialog__body {\n  max-height: none;\n}\n", ""]);

// exports
